import { render, staticRenderFns } from "./referrer-trophy.vue?vue&type=template&id=643146a0"
import script from "./referrer-trophy.vue?vue&type=script&lang=js"
export * from "./referrer-trophy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports